import { apiGet } from "./apiClient";

export interface ProgressPhoto {
  path: string;
  name: string;
  server_modified: string;
  temporary_link: string;
  /** data URI (data:image/jpeg;base64,...) of a w1024h768 thumbnail — use for carousel display. */
  thumbnail_url?: string;
}

export async function fetchProgressPhotosData(projectId?: string): Promise<ProgressPhoto[]> {
  const result = await apiGet({
    endpoint: "/get-project-progress-photos",
    params: projectId ? { projectId } : undefined,
    withAuth: true,
  });
  return Array.isArray(result) ? result : [];
}
